const envConfig = {
  endpoint: 'https://www.release.api.sobrerodas.club/',
  endpointv2: 'https://www.release.api.sobrerodas.club/v2/',
};

export default envConfig;
